angular.module('satv.playlist.pitch')

.factory('Pitch', ['config', '$resource', function(config, $resource) {
    return $resource(config.apiUri + '/playlists/pitches/:hash/:method', {
        hash: '@hash'
    }, {
        getEmail: {
            method: 'GET',
            params: {
                method: 'email'
            }
        },
        log: {
            method: 'POST',
            params: {
                method: 'log'
            }
        }
    });
}])

.factory('SinglePitchLoader', ['Pitch', '$q', function(Pitch, $q) {
    return function(params) {
        var delay = $q.defer();

        Pitch.get(params, function(resp) {
            delay.resolve(resp);
        }, function() {
            delay.reject('Unable to fetch Pitch');
        });

        return delay.promise;
    };
}])

.factory('PitchLoader', ['Pitch', 'LoaderFactory', function(Pitch, LoaderFactory) {
    return function(params) {
        return new LoaderFactory(Pitch, params);
    };
}])

.factory('PitchCsv', ['config', 'urlBuilder', function(config, urlBuilder) {
    return {
        getUrl: function(params) {
            return urlBuilder(config.apiUri + '/playlists/pitches?_format=csv', params);
        }
    };
}])

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/services/Pitch.js